module.exports = "\n      var $ = jQuery.noConflict(); $(document).ready(function()  { $('#carouselOffreService').carousel({ interval: 3000, cycle: true }); });\n"


//////////////////
// WEBPACK FOOTER
// /usr/local/app/~/raw-loader!/usr/local/app/~/source-map-loader!/usr/local/app/src/assets/js/offreservice-js.js
// module id = ../../../../raw-loader/index.js!../../../../source-map-loader/index.js!../../../../../src/assets/js/offreservice-js.js
// module chunks = 3